import { useCallback, useEffect, useState } from "react"
import {
  consentStatus,
  observeConsentStatusChange,
} from "@theconversation/shared-components/Didomi"
import { isEnabled } from "common/components/Didomi"
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig"

/**
 * Hook to get the Didomi consent status and observe changes in Didomi preferences.
 */
export const useConsent = (vendorId: string, purpose: string): boolean => {
  const regionConfiguration = useRegionConfig()
  const [consent, setConsent] = useState<boolean>(false)

  const handler = useCallback(async () => {
    if (!isEnabled(regionConfiguration)) {
      setConsent(true)
      return
    }

    try {
      const consent = await consentStatus({ vendorId, purpose })
      setConsent(consent)
    } catch (error) {
      console.warn("Error fetching consent status:", error)
      setConsent(false)
    }
  }, [regionConfiguration, vendorId, purpose])

  useEffect(() => {
    void handler()
    observeConsentStatusChange(handler)
  }, [handler])

  return consent
}
